import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\MarkAsUnReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsUnReadModelNotificationController.php
* @route '/api/mark-as-unread'
*/
const MarkAsUnReadModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkAsUnReadModelNotificationController.url(options),
    method: 'post',
})

MarkAsUnReadModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/mark-as-unread',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\MarkAsUnReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsUnReadModelNotificationController.php
* @route '/api/mark-as-unread'
*/
MarkAsUnReadModelNotificationController.url = (options?: RouteQueryOptions) => {
    return MarkAsUnReadModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\MarkAsUnReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsUnReadModelNotificationController.php
* @route '/api/mark-as-unread'
*/
MarkAsUnReadModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkAsUnReadModelNotificationController.url(options),
    method: 'post',
})

export default MarkAsUnReadModelNotificationController